import { useState, useEffect, useContext } from 'react';
import { YoutubeService } from '../services';
import { TranscriptionDialogContext } from '../context';

const useYouTubeVideoInfo = (url: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [id, setId] = useState(null);
  const { setApriori } = useContext(TranscriptionDialogContext);

  useEffect(() => {
    let isMounted = true; // To handle component unmount scenarios

    const fetchVideoInfo = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await YoutubeService.getVideoInfo(url);

        if (isMounted && data?.items[0]) {
          setApriori({
            title: data.items[0]?.snippet.title || `My Song ${new Date().toLocaleString()}`,
            composer: data.items[0]?.snippet.channelTitle || 'unknown',
          });
          setId(data.items[0]?.id);
        }
      } catch (err) {
        if (isMounted) {
          setId(YoutubeService.getIdFromYoutubeUrl(url));
          setError(err.message || 'Failed to fetch video info');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (url) {
      fetchVideoInfo();
    }

    return () => {
      isMounted = false; // Cleanup function
    };
  }, [url]);

  return { loading, error, id };
};

export default useYouTubeVideoInfo;
